<template>
  <div class="vipPrivilege-wrap">
    <div class="vipPrivilege">
      <div data-v-6e3c2862="" class="privileges">
        <div data-v-6e3c2862="" class="group-t"><span data-v-6e3c2862="" class="line-left"></span>VIP尊享特权<span data-v-6e3c2862="" class="line-right"></span></div>
      </div>
      <div style="margin: 10px">
        <div v-for="(item, index) in vipLis" :key="index">
          <div class="vip-box" :class="'vip-bg' + (index + 1)" v-show="item.id == active">
            <div class="usr-vip open">{{item.vip_id <= userInfo.vip ? '已解锁':'未解锁'}}</div>
            <div style="font-size: 48px; font-weight: 600; color: #fff; position: absolute; top: 40px; left: 20px">{{ item.vipname }}</div>
            <div class="vip-icon"><img :src="'../../../static/image/vip/' + (index) + '.png'" /></div>
            <div style="border-bottom: 2px solid #e6e6e6; width: 90%; margin: 0 auto; height: 140px"></div>
            <div style="width: 90%; margin: 0 auto; color: #fff; font-size: 16px; height: 48px; line-height: 48px;display: none;">已晋级</div>
          </div>
        </div>
        <van-tabs background="#141414" color="#cca352" title-active-color="#cca352" title-inactive-color="#6a6a73" v-model="active">
          <van-tab v-for="(item, index) in vipLis" :title="item.vipname" :key="index" :name="item.id"></van-tab>
        </van-tabs>
      </div>

      <div style="width: 90%; margin: 0px auto">
        <div v-for="(item, index) in vipLis" :key="index">
          <div v-show="item.id == active">
            <van-row style="text-align: center; line-height: 1.6;height: 97px;">
              <van-col :span="8">
                <van-icon name="gold-coin-o" size="18" color="#fff" />
                <p style="font-size: 18px; color: #fff">{{ item.be_promoted_bonus }}</p>
                <p>晋级奖金</p>
                <div style="color:#cca352;border: 1px solid #cca352;width: 80%;margin: 0 auto;" v-if="bonus.filter(e => e.vip_level == item.id && e.bonus_type == 1 && e.status == 0).length > 0 "
                  @click="doBonus(bonus.filter(e => e.vip_level == item.id && e.bonus_type == 1 && e.status == 0)[0])">领取</div>
              </van-col>
              <van-col :span="8">
                <van-icon name="gold-coin-o" size="18" color="#fff" />
                <p style="font-size: 18px; color: #fff">{{ item.week_bonus }}</p>
                <p>周奖金</p>
                <div style="color:#cca352;border: 1px solid #cca352;width: 80%;margin: 0 auto;" 
                v-if="bonus.filter(e => e.vip_level == item.id && e.bonus_type == 2 && e.status == 0).length > 0 "
                @click="doBonus(bonus.filter(e => e.vip_level == item.id && e.bonus_type == 2 && e.status == 0)[0])">领取</div>
              </van-col>
              <van-col :span="8">
                <van-icon name="gold-coin-o" size="18" color="#fff" />
                <p style="font-size: 18px; color: #fff">{{ item.month_bonus }}</p>
                <p>月奖金</p>
                <div style="color:#cca352;border: 1px solid #cca352;width: 80%;margin: 0 auto;" 
                v-if="bonus.filter(e => e.vip_level == item.id && e.bonus_type == 3 && e.status == 0).length > 0 "
                @click="doBonus(bonus.filter(e => e.vip_level == item.id && e.bonus_type == 3 && e.status == 0)[0])">领取</div>
              </van-col>
            </van-row>
            <van-divider />
            <van-row style="color: #fff;">
              <van-col :span="7">周奖金存款要求</van-col>
              <van-col :span="5">{{ item.week_deposit }}</van-col>
              <van-col :span="7">月奖金存款要求</van-col>
              <van-col :span="5">{{ item.week_bet }}</van-col>
            </van-row>
            <van-row style="color: #fff;">
              <van-col :span="7">周奖金投注要求</van-col>
              <van-col :span="5">{{ item.month_deposit }}</van-col>
              <van-col :span="7">月奖金投注要求</van-col>
              <van-col :span="5">{{ item.month_bet }}</van-col>
            </van-row>
            <van-divider />
          </div>
        </div>
      </div>

      <div v-if="vipLis.length > 0">
        <div v-for="(item, index) in vipLis" :key="index">
          <div data-v-3190160e="" class="_3di95a3H" v-show="item.id == active">
            <div data-v-3190160e="" class="_1HjYPvvp">
              <p data-v-3190160e="">VIP{{ index }}达成及返水比例</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">累计流水</p>
              <p data-v-3190160e="">{{ item.totalgame }} / {{ item.flow }}</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">累计充值</p>
              <p data-v-3190160e="">{{ item.paysum }} / {{ item.recharge }}</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">真人返水</p>
              <p data-v-3190160e="">{{ item.realperson }}%</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">电子返水</p>
              <p data-v-3190160e="">{{ item.electron }}%</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">棋牌返水</p>
              <p data-v-3190160e="">{{ item.joker }}%</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">体育返水</p>
              <p data-v-3190160e="">{{ item.sport }}%</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">彩票返水</p>
              <p data-v-3190160e="">{{ item.lottery }}%</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack" style="border-bottom: 1px solid #e9edf6">
              <p data-v-3190160e="">电竞返水</p>
              <p data-v-3190160e="">{{ item.e_sport }}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 60px"></div>
  </div>
</template>
<script>
export default {
  name: 'vip',
  data () {
    return { 
      vipLis: [], 
      active: null ,
      bonus: null,
      userInfo: {}
  };
  },
  created () {
    let that = this;
    that.userInfo =  JSON.parse(localStorage.getItem('userInfo'))
    that.usrBonus();
  },
  methods: {
    onChange (val) {
      this.active = this.vipLis[val].id;
    },
    uservip () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.vipLis = res.data;
            that.active = this.userInfo.vip
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    usrBonus(){
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .get('/api/userBonus', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bonus = res.data
            that.uservip()
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    doBonus (item) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .get('/api/doUserBonus', {id:item.id})
        .then(res => {
           that.$parent.showTost(0, res.message);

          if (res.code == 200) {
            let that = this;
            that.usrBonus();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted () {
    let that = this;
    
  },
  updated () {
    let that = this;
  },
};
</script>
<style lang="scss" scoped>
.vip-box {
  width: 100%;
  height: 190px;
  border-radius: 8px;
  position: relative;
  background-repeat: no-repeat;
  background-size: 102% 100%;
  .usr-vip {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    border-top-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background: rgb(0, 0, 0, 0.7);
    color: #fff;
    font-size: 12px;
    padding: 8px 14px;
  }
  .vip-icon {
    position: absolute;
    width: 130px;
    height: 130px;
    z-index: 3;
    right: 20px;
    top: -10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.vip-bg1 {
  background-image: url(../../../static/image/vip/vip_bg_1.webp);
}
.vip-bg2 {
  background-image: url(../../../static/image/vip/vip_bg_2.webp);
}
.vip-bg3 {
  background-image: url(../../../static/image/vip/vip_bg_3.webp);
}
.vip-bg4 {
  background-image: url(../../../static/image/vip/vip_bg_4.webp);
}
.vip-bg5 {
  background-image: url(../../../static/image/vip/vip_bg_5.webp);
}
.vip-bg6 {
  background-image: url(../../../static/image/vip/vip_bg_6.webp);
}
.vip-bg7 {
  background-image: url(../../../static/image/vip/vip_bg_7.webp);
}
.vip-bg8 {
  background-image: url(../../../static/image/vip/vip_bg_8.webp);
}
.vip-bg9 {
  background-image: url(../../../static/image/vip/vip_bg_9.webp);
}
.vip-bg10 {
  background-image: url(../../../static/image/vip/vip_bg_10.webp);
}

._3di95a3H {
  width: 90%;
  height: auto;
  margin: 15px auto;
}
._3di95a3H ._1HjYPvvp:first-of-type {
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
}

._3di95a3H ._1HjYPvvp {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: #fff;
  border: 1px solid #e9edf6;
  border-bottom: none;
  line-height: 1.5;
  overflow: hidden;
}
._3di95a3H ._1HjYPvvp p {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  color: #3f5075;
  font-size: 14px;
  min-height: 36px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 0 5px;
}
._3di95a3H ._1HjYPvvp {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: #141414;

  border: 1px solid #e9edf6;
  border-bottom: none;
  line-height: 1.5;
  overflow: hidden;
}
._3di95a3H ._1HjYPvvp p:nth-child(n + 2) {
  border-left: 1px solid #e9edf6;
}

._3di95a3H .returnBack p {
  min-height: 41.6px;
}
._3di95a3H ._1HjYPvvp p {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  color: #fff;
  font-size: 14px;
  min-height: 36px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 0 5px;
}
.vipPrivilege-wrap .vipPrivilege .privileges {
  padding: 10px 0;
  background: #151519;
  border-radius: 15px 15px 0 0;
}
.group-t {
  text-align: center;
  font-size: 16px;
  color: #e0e0e0;
  margin-bottom: 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.vipPrivilege-wrap .vipPrivilege .group-t .line-left {
  width: 51px;
  height: 1px;
  background-color: hsla(0, 0%, 100%, 0.1);
  display: inline-block;
  margin-right: 18px;
}
.vipPrivilege-wrap .vipPrivilege .group-t .line-right {
  width: 51px;
  height: 1px;
  background-color: hsla(0, 0%, 100%, 0.1);
  display: inline-block;
  margin-left: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/vip.vue